import { useMonthlyPerformanceRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetMonthlyPerformanceCommonInfoQuery } from "../../features/api/monthlyPerformanceApi";

export { useMonthlyPerformanceRoutes };

interface MonthlyPerformancesProps {
    isCumulative: boolean;
}

const MonthlyPerformances = ({ isCumulative }: MonthlyPerformancesProps) => {
  let title = isCumulative ? "عملکرد ماهانه تجمعی" : "عملکرد ماهانه";
  

  return GetDefaultIndex({
    title: title,
    query: useGetMonthlyPerformanceCommonInfoQuery,
    queryArgs: isCumulative
  })();
};

export default MonthlyPerformances;